<template lang='pug'>
div.standard-list-item
  div.d-flex.flex-row.top-row
    div.d-flex.flex-row.align-center.flex-grow-1(@click="dispatchVirtualList('on-press-item')")
      v-icon(small color="grey lighten-1") {{resolveShareIcon(source)}}
      p.body-1(:class="{ 'text--primary': source.name, 'name-hint': !source.name && !isSelected, 'font-weight-bold': isSelected }") {{ resolveItemName(source) }}
      p.body-2.text--disabled(v-if="!isThinScreen") {{ source.lastModified }}
      v-progress-circular(v-if="isUpdating"
                          :color='loadingIndicatorUi.color'
                          :width='loadingIndicatorUi.size'
                          indeterminate)
    div(@click.stop.prevent)
      v-icon(@click.stop.prevent="dispatchVirtualList('on-edit-item')") edit
      v-menu(@click.native.stop.prevent)
        template(v-slot:activator="{ on }")
          v-btn(slot="activator" icon v-on="on" :disabled="source.isActionDisabled()")
            v-icon more_vert
        v-list
          v-list-item(
            v-for="(menuItem, menuIndex) in resultActions",
            :key="menuIndex",
            @click="onMenuItemSelect(menuIndex)"
          )
            v-list-item-title {{ menuItem }}

  p.body-2.text--secondary(v-if="source.notes") {{ resolveItemNotes(source) }}
</template>

<script>
import Vue from 'vue'
import ComponentDispatchMixin from '../../../mixins/ComponentDispatchMixin'
import { getShareIcon } from '@/components/util/shareIconUtil'
import dataBrowserResource from '@/resources/dataBrowser'
import uiConstant from '@/resources/uiConstant'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters } = createNamespacedHelpers('day6CharacterBrowser')

export default {
  name: 'CharacterDataListItem',
  mixins: [ComponentDispatchMixin],
  props: {
    index: Number,
    source: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      loadingIndicatorUi: uiConstant.loadingIndicator,
      isThinScreen: this.isThinScreenWidthVuetify(this.$vuetify),
      resultActions: [
        dataBrowserResource.moveToTop,
        dataBrowserResource.delete
      ]
    }
  },
  computed: {
    ...mapState(['isSettingModifiedId']),
    ...mapGetters([
      'isSavingName',
      'isSavingNotes',
      'isSharingCharacter',
      'isDeletingCharacter'
    ]),

    isSelected () {
      return this.source.getSelectedId() === this.source.id
    },
    isUpdating () {
      const id = this.source.id
      return this.isSavingName(id) ||
        this.isSavingNotes(id) ||
        this.isSharingCharacter(id) ||
        this.isSettingModifiedId === id ||
        this.isDeletingCharacter(id)
    }
  },
  methods: {
    resolveItemName (item) {
      return dataBrowserResource.getCharacterDataName(item)
    },
    resolveShareIcon (item) {
      return getShareIcon(item.shareLevel)
    },
    resolveItemNotes (item) {
      // TODO Truncate notes on smaller screen
      return item.notes
    },
    onMenuItemSelect (menuIndex) {
      const action = this.resultActions[menuIndex]
      switch (action) {
        case dataBrowserResource.delete:
          this.dispatchVirtualList('on-delete-item')
          break
        case dataBrowserResource.moveToTop:
          this.dispatchVirtualList('on-move-item-top')
          break
        default:
          Vue.logger.log(`Menu action not found ${menuIndex}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.standard-list-item {
  padding: 16px;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  p {
    margin: 0;
  }
}

.top-row >*>*:not(:last-child) {
  margin-right: 16px;
}

.body-1.name-hint {
  // TODO Use common/variable color
  color: #888;
}

.notes-data {
  margin: 0;
  // TODO Use common styles
  font-size: 1em;
}
</style>
